import { render, staticRenderFns } from "./UnsubmittedIncidentsToolbar.vue?vue&type=template&id=6c1d0ed4&"
import script from "./UnsubmittedIncidentsToolbar.vue?vue&type=script&lang=js&"
export * from "./UnsubmittedIncidentsToolbar.vue?vue&type=script&lang=js&"
import style0 from "./UnsubmittedIncidentsToolbar.vue?vue&type=style&index=0&id=6c1d0ed4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports